import { useEffect, useState } from 'react'
import { useGet } from '../apiHooks'
import { config } from '../../components/Init/Init'
import { tokenizer } from '../../services/utils'
import { usePlayerStore } from '../../services/store'

export const useGetAccountSsn = () => {
  const playerStore = usePlayerStore()
  const playerLoginUser = playerStore.use.loginUser()

  const { GET, isLoading: isSsnInfoLoading } = useGet()
  const [ssnData, setSsnData] = useState({
    lastModified: '',
    provided: false
  })
  const getTaxInfoUrl = tokenizer(config.kycServiceTaxUrl + config.getAccountTaxInfo, {
    '{userId}': playerLoginUser.userId
  })

  useEffect(() => {
    GET(getTaxInfoUrl).then(data => {
      setSsnData(data)
    })
  }, [getTaxInfoUrl])

  return { ssnData, setSsnData, isSsnInfoLoading }
}
